import React from 'react'
import { Link } from 'react-router-dom'
import './webaccessibility.scss'
const WebAccessibilityContent = () => {
  return (
    <div className='webaccessibity_content'>
        <div className='text'>
            <p>Welcome to our site. Now, let’s make sure you get what you need. Our site utilizes Cascading Style Sheets (CSS), a benefit to screen readers.</p>
            <p>We want to make sure everyone can access the appropriate information on our site. If you’re having trouble 
                viewing or accessing authorized material, please call 800-473-6879, or <Link to="">reach us</Link> here. 
                We’re here to help.</p>
        </div>
    </div>
  )
}

export default WebAccessibilityContent
